module.exports = __webpack_public_path__ + "static/media/jsslogoicon.233e515a.png";